import React from "react";
import { MdCheckBox, MdCheckBoxOutlineBlank, MdCircle, MdOutlineCircle } from "react-icons/md";
import { FixedSizeList as List } from "react-window";

interface VirtualizedRowProps {
  index: number;
  style: React.CSSProperties;
  data: {
    items: any[];
    menuIndex: number;
    createMenuItem: (menuItem: any, tick: JSX.Element | undefined, multiSelect: any, itemCount: number) => JSX.Element;
    multiSelect: any;
    hasTicks: boolean;
  };
}

const VirtualizedRow = React.memo(({ index, style, data }: VirtualizedRowProps) => {
  const { items, menuIndex, createMenuItem, multiSelect, hasTicks } = data;
  const menuItem = items[index];

  const multiSelectForElement = Array.isArray(multiSelect)
    ? multiSelect[menuIndex]
    : multiSelect;

  const tickElement = hasTicks ? (
    multiSelectForElement ? (
      menuItem.selected ? (
        <MdCheckBox />
      ) : (
        <MdCheckBoxOutlineBlank />
      )
    ) : menuItem.selected ? (
      <MdCircle />
    ) : (
      <MdOutlineCircle />
    )
  ) : undefined;

  const menuItemElement = createMenuItem(menuItem, tickElement, multiSelect, items.length);

  return (
    <div style={style}>
      {menuItemElement}
    </div>
  );
});

export const renderVirtualizedMenu = (
  filteredMenuItems: any[][],
  menuIndex: number,
  createMenuItem: (menuItem: any, tick: JSX.Element | undefined, multiSelect: any, itemCount: number) => JSX.Element,
  multiSelect: boolean | undefined,
  hasTicks: boolean
): JSX.Element | null => {
  const items = filteredMenuItems[menuIndex];

  if (!items || items.length === 0) {
    return null;
  }

  const itemData = {
    items,
    menuIndex,
    multiSelect,
    createMenuItem,
    hasTicks
  };

  return (
    <div className="virtualized-container">
    <List
      height={Math.min(300, items.length * 35)}
      width="100%"
      itemCount={items.length}
      itemSize={35}
      itemData={itemData}
      className="virtualized-dropdown-list"
    >
      {VirtualizedRow}
    </List>
    </div>
  );
};
